<div class="job-order-container">
  <app-vertical-tabs [tabs]="getTabList()" (tabSelected)="selectTab($event)"></app-vertical-tabs>

  <div class="section jo-details-section card-layout" [hidden]="selectedTab !== 'basicDetailsSection'">
    <app-dynamic-form
    [formConfig]="dynamicForm"
    [formGroup]="jobOrderForm"
    >
    </app-dynamic-form>
  </div>

  <div class="section" [hidden]="selectedTab !== 'itemDetailsSection'">
    <app-item-selector-panel
    #itemSelectorComponent
    [entity]="'CONTAINER'"
    [items]="containerList"
    [itemsTitle]="'Container List'"
    [listReadOnly]="readOnlyMode"
    [allowedItemSize]="-1"
    [validateBeforeItemAddition] = "true"
    (onItemSelection) = "handleItemSelection($event)"
    (onItemDeletion) = "handleItemDeletion($event)"
    (onItemAddition) = "handleItemAddition($event)"
    (onItemAdditionRequest)="validateItemAddition($event)"
    [searchConfig]="containerSearchConfig"
    >
    </app-item-selector-panel>
  </div>

  <div
    class="section service-section card-layout"
    [hidden]="selectedTab !== 'serviceVendorTab'"
    >

    <div class="actions">
      <button *ngIf="!readOnlyMode"
        type="button"
        class="manage-service-button secondary_button"
        (click)="configureServiceForContainer()"
      >
        <app-svg-icon
          class="image-icon"
          [path]="'assets/icons/add_plus_icon.svg'"
        ></app-svg-icon>
        <span>Add Services</span>
      </button>
    </div>

    <app-accordion-table
      #accordianTableComponent
      [readOnly]="true"
      [tableHeaderAndData]="containerTableHeaderAndData"
      (onAccordionOpen)="loadAccordionContent($event)"
    ></app-accordion-table>
  </div>
</div>
